var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOverview = function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.5H3v-.405l3.75-3.75 2.85 2.85a.75.75 0 0 0 1.058 0l5.624-5.625a.75.75 0 1 0-1.057-1.065l-5.1 5.1-2.843-2.85a.75.75 0 0 0-1.057 0L3 12.972V9.096l3.75-3.75 2.1 2.1a.75.75 0 0 0 1.058 0L13.5 3.852l1.643 1.643A.75.75 0 0 0 16.2 4.43l-2.182-2.167a.75.75 0 0 0-1.058 0l-3.6 3.6-2.092-2.1a.75.75 0 0 0-1.058 0L3 6.973V2.75a.75.75 0 0 0-1.5 0v13.5a.75.75 0 0 0 .75.75h13.5a.75.75 0 1 0 0-1.5Z"
  })));
};
export default SvgOverview;